import { useTranslation } from "react-i18next";
import ConvertToString from "../../../components/Converter";
import Millimetre from "../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";

function ExistingGroutCover({ cist }) {
  const { t } = useTranslation("translation");
  const CnomFormula = `\\displaystyle c_{_{nom}} = \\frac{D+a_{min}-D_a}{2}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.existingGroutCover")}</p>}
      formulaValue={<ToolTip id={"CnomFormula"} type={IconType.FORMULA} formula={CnomFormula} />}
      indicesValue={
        <span>
          c<sub>nom</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(cist, 0)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default ExistingGroutCover;
